import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e94bb45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "brand-container mt-3" }
const _hoisted_2 = { class: "row mb-4" }
const _hoisted_3 = { class: "card-brand" }
const _hoisted_4 = { class: "row mb-3" }
const _hoisted_5 = { class: "card-brand" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardAccomplishedSegment = _resolveComponent("DashboardAccomplishedSegment")!
  const _component_DashboardTargetAccomplished = _resolveComponent("DashboardTargetAccomplished")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_DashboardAccomplishedSegment, {
          accomplishedSegment: _ctx.setFunction('targetAccomplished'),
          loading: _ctx.setFunction('loadingTargetAccomplished'),
          access: _ctx.setFunction('access'),
          salesChannelName: _ctx.selectedchannel.fullname.toUpperCase()
        }, null, 8, ["accomplishedSegment", "loading", "access", "salesChannelName"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_DashboardTargetAccomplished, {
          targetAccomplished: _ctx.setFunction('targetAccomplished'),
          loading: _ctx.setFunction('loadingTargetAccomplished'),
          access: _ctx.setFunction('access'),
          salesChannelName: _ctx.selectedchannel.fullname.toUpperCase()
        }, null, 8, ["targetAccomplished", "loading", "access", "salesChannelName"])
      ])
    ])
  ]))
}